import React from 'react';

export const Calendar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M2.81818 1V1.43478H1V11H11V1.43478H9.18182V1H8.27273V1.43478H3.72727V1H2.81818ZM1.90909 2.30435H2.81818V2.73913H3.72727V2.30435H8.27273V2.73913H9.18182V2.30435H10.0909V3.17391H1.90909V2.30435ZM1.90909 4.04348H10.0909V10.1304H1.90909V4.04348ZM4.63636 4.91304V5.78261H5.54545V4.91304H4.63636ZM6.45455 4.91304V5.78261H7.36364V4.91304H6.45455ZM8.27273 4.91304V5.78261H9.18182V4.91304H8.27273ZM2.81818 6.65217V7.52174H3.72727V6.65217H2.81818ZM4.63636 6.65217V7.52174H5.54545V6.65217H4.63636ZM6.45455 6.65217V7.52174H7.36364V6.65217H6.45455ZM8.27273 6.65217V7.52174H9.18182V6.65217H8.27273ZM2.81818 8.3913V9.26087H3.72727V8.3913H2.81818ZM4.63636 8.3913V9.26087H5.54545V8.3913H4.63636ZM6.45455 8.3913V9.26087H7.36364V8.3913H6.45455Z"
        fill="black"
      />
    </svg>
  );
}
